import { render, staticRenderFns } from "./ImageActivity.vue?vue&type=template&id=3764352b&"
import script from "./ImageActivity.vue?vue&type=script&lang=js&"
export * from "./ImageActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports